import { Link } from "@StarberryUtils";
import React, { useState, useEffect } from "react"
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby"
import Select from 'react-select';
import ModalTiny from "react-bootstrap/Modal"
import { GetURL } from "../../Common/site/functions"
import axios from "axios";
import { navigate } from "@reach/router"

import { inViewOptions, contentItemStagger, contentItem } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

// Style
import './StaticBanner.scss';
import LoadExternalScript from "../../Utils/load-external-script";
import NewsLetterForm from "../../Forms/newsletter-form";
import ContactForm from "../../Forms/contact-form";
import _ from "lodash";
import { containerVariants } from "../../Utils/animations";
const YOUTUBE_API = "AIzaSyDCZxSCPj9PZXJU6W28UJ1zCn1Psdr9T7Y";
const CHANNEL_ID = "UCH8xPtLWVF8NlVFqM8XWzQA";

const StaticBanner = ({ page, handlerSelect, category }) => {
  const locRatingScriptsJs = 'https://apis.google.com/js/platform.js';
  const data = useStaticQuery(graphql`
    query {
      glstrapi {
        videoCategories(sort:"Sort:asc", where:{Publish:true})  {
          Name
          Title
          Sub_Title
          Sort
          Publish
          URL
          id
        }
      }
    }
  `);


  const video_categories = data.glstrapi.videoCategories
  const [options, setOptions] = React.useState([]);
  const [playLists, setPlayLists] = React.useState([]);
  const [selectedOption, setSelectedOption] = useState(null)
  const [pageHeading, setPageHeading] = useState({Title: page?.Title, Sub_Title:page?.Sub_Title})
  var handleChange = selectedOption => {
    setSelectedOption(selectedOption);
    handlerSelect(selectedOption)     
    if(selectedOption.value != "all_videos"){  
      savePageHeading(selectedOption.value)
      navigate(`/videos/${selectedOption.value}/`)
    }else{
      savePageHeading(selectedOption.value)
      navigate(`/videos/`)
    }
   
  };

  const youtubeBtn = React.createRef();

  const [modalContactformOpen, setContactformOpen] = React.useState(false);
  const closeContactformModal = () => {
    setContactformOpen(false);
  }


  const savePageHeading = (val) => {
    let findVideo = video_categories.find((element) => element.URL == val)
    if(findVideo){
      setPageHeading(findVideo)
    } else{
      setPageHeading({Title: page.Title, Sub_Title:page.Sub_Title})
    }
  }

  let url_1 = ['']
  let url_2 = ['']
  if (page && page.Header_CTA_1_Link) {
    url_1 = GetURL(page.Header_CTA_1_Link.id)
  }
  if (page && page.Header_CTA_2_Link) {
    url_2 = GetURL(page.Header_CTA_2_Link.id)
  }

  const openForm = (formName) => {
    if (formName === "Contact_Form") {
      setContactformOpen(true);
    }
  }

  const getPlayLists = async () => {
    let play_list = await axios.get(`https://youtube.googleapis.com/youtube/v3/playlists?part=snippet&channelId=${CHANNEL_ID}&key=${YOUTUBE_API}`);
    if (play_list && play_list.data && play_list.data.items) {
      _.forEach(play_list?.data?.items, (cat, i) => {
        options.push({ value: cat.id, label: cat?.snippet.title })
      })
      if (!_.isEmpty(options)) {
        setOptions(options);
        setSelectedOption({ value: options[0].value, label: options[0].label });
        handlerSelect({ value: options[0].value, label: options[0].label })
      }

    }
  }
  useEffect(() => { 
    let option = [{ value: "all_videos", label: "All" }]
    if (video_categories) {
      _.forEach(video_categories, (cat, i) => {
        option.push({ value: cat.URL, label: cat?.Name })
      })
      if (!_.isEmpty(option)) {
        setOptions(option);
        let selectedOpt = { value: "all_videos", label: "All" }; 
        if (category) {
          selectedOpt = option.find((element) => element.value == category)  
          savePageHeading(category)
        } 
        setSelectedOption(selectedOpt); 
        handlerSelect(selectedOpt)
      } 
    }
  }, [video_categories]); 
  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          className={`static-banner ${page?.Alias}`}
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={contentItemStagger}
        >
          <LoadExternalScript src={locRatingScriptsJs} defer="true" />

          <Container>
            <Row>
              <Col>
                {page &&
                  <div
                    className="banner-content"
                  >

                    {page.Page_Title_SM &&
                      <motion.span className="sm-text" variants={contentItem}>{page.Page_Title_SM}</motion.span>
                    }
                    <motion.h1 variants={contentItem}>{pageHeading.Title}</motion.h1>
                    <motion.p variants={contentItem}>{pageHeading.Sub_Title}</motion.p>

                    {(page.CTA_1_Label || page.CTA_2_Label) &&
                      <motion.div
                        className="banner-section-btn"
                        variants={contentItem}
                      >
                        {page.CTA_1_Label && page.CTA_1_Form &&
                          <Button onClick={() => { openForm(page.CTA_1_Form) }} className="btn btn-primary">{page.CTA_1_Label}<i className="icon-arrow"></i></Button>
                        }

                        {page.CTA_2_Label && page.CTA_2_Form &&
                          <Button onClick={() => { openForm(page.CTA_2_Form) }} className="btn btn-primary">{page.CTA_2_Label}<i className="icon-arrow"></i></Button>
                        }

                        {page.CTA_1_Label && page.Header_CTA_1_Link && url_1[1] == 'Internal' ?
                          <Link to={`/${url_1[0]}`} className="btn btn-primary">{page.CTA_1_Label}<i className="icon-arrow"></i></Link>
                          :
                          page.CTA_1_Label && page.Header_CTA_1_Link && url_1[1] == 'External' ?
                            <a href={`${url_1[0]}`} target="_blank" className="btn btn-primary">{page.CTA_1_Label}<i className="icon-arrow"></i></a>
                            : ''
                        }

                        {page.CTA_2_Label && page.Header_CTA_2_Link && url_2[1] == 'Internal' ?
                          <Link to={`/${url_2[0]}`} className="btn btn-primary">{page.CTA_2_Label}<i className="icon-arrow"></i></Link>
                          :
                          page.CTA_2_Label && page.Header_CTA_2_Link && url_2[1] == 'External' ?
                            <a href={`${url_2[0]}`} target="_blank" className="btn btn-primary">{page.CTA_2_Label}<i className="icon-arrow"></i></a>
                            : ''
                        }
                      </motion.div>
                    }
                    {/*<div class="g-ytsubscribe" data-channel="GoogleDevelopers" data-layout="default" data-count="hidden"></div>*/}
                    {page.Show_News_Form &&
                      <motion.div className="form-wrapper" variants={contentItem}>
                        <NewsLetterForm title="News Letter" />
                      </motion.div>
                    }

                    {page.Show_Youtube_Form && options.length > 1 &&
                      <motion.div className="banner-section-btn" variants={contentItem}>
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={options}
                          defaultMenuIsOpen={false}
                          className={`select-form-control video-select-box`}
                          classNamePrefix={`reactSelect2`}
                        />

                        {/* <Link to="https://www.youtube.com/channel/UCH8xPtLWVF8NlVFqM8XWzQA?sub_confirmation=1" target="_blank" className="btn btn-primary youtube-btn" ref={youtubeBtn}><i className="icon-youtube"></i> Subscribe to YouTube</Link> */}
                      </motion.div>
                    }
                  </div>
                }
              </Col>
            </Row>
          </Container>
          <ModalTiny size="lg" show={modalContactformOpen} onHide={closeContactformModal} className="modal-form">
            <ModalTiny.Header closeButton className="contact-close-btn">
              <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">General Enquiry</h2></ModalTiny.Title>
            </ModalTiny.Header>
            <ModalTiny.Body className="event-section"><ContactForm title="General Enquiry" /></ModalTiny.Body>
          </ModalTiny>
        </motion.section>
      )}
    </InView>
  )
}



export default StaticBanner